<template>
  <el-container class="home-contra">
    <el-header>
      <my-header></my-header>
    </el-header>
    <el-container>
      <my-aside></my-aside>
      <el-main style="background-color: rgb(238, 241, 246)">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import MyHeader from "../../components/Header/MyHeader.vue";
import MyAside from "../../components/MyAside/MyAside.vue";
export default {
  components: { MyHeader, MyAside },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.home-contra {
  height: 100vh;
}
.el-main {
  background-color: #e9eef3;
}
.el-header {
  background-color: #282929;
}
</style>